module.exports = __webpack_public_path__ + "img/resized-APP-0026-1.be720f16.png";